document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".wishlist-btn");

  function getWishlist() {
    try {
      const data = JSON.parse(localStorage.getItem("wishlist") || "[]");
      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(wishlist) {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    // Updates the header count immediately in the same tab.
    document.dispatchEvent(
      new CustomEvent("wishlist:updated", {
        detail: { wishlist: wishlist }
      })
    );
  }

  function updateButton(button) {
    const productHandle = button.dataset.productHandle;
    const isActive = getWishlist().includes(productHandle);
    const iconMarkup = `<svg class="wishlist-btn__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78Z" /></svg>`;

    if (button.classList.contains("wishlist-icon-only")) {
      button.innerHTML = iconMarkup;
      button.setAttribute(
        "aria-label",
        isActive ? "Remove from Wishlist" : "Add to Wishlist"
      );
    } else {
      const label = isActive ? "Remove from Wishlist" : "Add to Wishlist";
      button.innerHTML = `${iconMarkup}<span>${label}</span>`;
      button.setAttribute("aria-label", label);
    }

    button.setAttribute("aria-pressed", String(isActive));
    button.classList.toggle("activee", isActive);
  }

  function updateAllButtons() {
    document.querySelectorAll(".wishlist-btn").forEach(updateButton);
  }

  buttons.forEach(function (button) {
    updateButton(button);

    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      const productHandle = button.dataset.productHandle;
      let wishlist = getWishlist();

      if (wishlist.includes(productHandle)) {
        wishlist = wishlist.filter(function (handle) {
          return handle !== productHandle;
        });
      } else {
        wishlist.push(productHandle);
      }

      saveWishlist(wishlist);
      updateAllButtons();
    });
  });

  // Keeps buttons synchronized when another script changes the wishlist.
  document.addEventListener("wishlist:updated", updateAllButtons);

  // Works when the wishlist changes in another browser tab.
  window.addEventListener("storage", function (event) {
    if (event.key === "wishlist") {
      updateAllButtons();
      document.dispatchEvent(new CustomEvent("wishlist:updated"));
    }
  });
});